import styled from 'styled-components';

import { LinkButton } from 'src/components/Button/LinkButton';

const baseFontSize = 12;

export const StyledFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: .5rem;

  svg {
    color: var(${props => props.theme.promptCopyAndSvgColor});
  }
`;

export const LearnMoreButton = styled(LinkButton)`
  font-style: normal;
  font-weight: 400;
  font-size: ${baseFontSize}px;
  text-align: right;
  line-height: 1;
  padding-top: 0.25em;
  padding-bottom: 0.25em;
  text-decoration: underline;
`;
